import { useState } from "react";

const NAME_RE = /^[A-Za-z. ]+$/;

// Company-level Air12 Sender Agreement acceptance (distinct from Quote acceptance). Shows the exact
// rendered Agreement, a self-declared full legal name and the company-only authority affirmation.
export const AgreementAcceptPanel = ({ agreement, loading, error, onRetry, onAccept, busy, testIdPrefix = "agreement" }) => {
  const [name, setName] = useState("");
  const [affirmed, setAffirmed] = useState(false);
  const t = (s) => `${testIdPrefix}-${s}`;

  if (loading) return <div className="text-sm text-[hsl(var(--muted))]" data-testid={t("loading")}>Loading the Air12 Sender Agreement…</div>;
  if (error) {
    return (
      <div className="text-sm text-red-600" data-testid={t("error")}>
        {error} {onRetry && <button className="underline" onClick={onRetry} data-testid={t("retry")}>Retry</button>}
      </div>
    );
  }
  if (!agreement) return null;
  const valid = affirmed && NAME_RE.test(name.trim());

  return (
    <div className="space-y-3" data-testid={t("panel")}>
      <div>
        <div className="text-sm font-semibold">{agreement.title || "Air12 Sender Agreement"}</div>
        <div className="overline text-[10px]" data-testid={t("version-label")}>Version {agreement.version} · Published {agreement.publication_date}</div>
      </div>
      <p className="text-xs text-[hsl(var(--muted))]">This Agreement binds your company. Please read it and confirm you are authorised to accept it.</p>
      <div className="border rounded-sm p-3 max-h-72 overflow-y-auto whitespace-pre-line text-[13px] leading-relaxed bg-[hsl(var(--bg))]" data-testid={t("view")}>
        {agreement.wording}
      </div>
      <label className="block">
        <div className="overline mb-1.5">FULL LEGAL NAME OF THE AUTHORISED PERSON</div>
        <input className="input-field" value={name} onChange={(e) => setName(e.target.value)} data-testid={t("name-input")} />
      </label>
      <label className="flex items-start gap-2 cursor-pointer text-sm" data-testid={t("affirm-label")}>
        <input type="checkbox" className="mt-0.5" checked={affirmed} onChange={(e) => setAffirmed(e.target.checked)} data-testid={t("affirm-checkbox")} />
        <span>{agreement.authority_affirmation_text}</span>
      </label>
      <button className="btn-primary" disabled={busy || !valid} onClick={() => onAccept(name.trim())} data-testid={t("accept-button")}>
        {busy ? "Accepting…" : (agreement.action_label || "Accept Sender Agreement")}
      </button>
    </div>
  );
};
